import React, { useCallback,useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import "./EditItem.css";

const BASE_API =
  process.env.BASE_API_URL ||
  "https://scanmymenu-nm38.onrender.com/api";

export default function EditItem() {

  const { itemId } = useParams();
  const navigate = useNavigate();

  const restaurantId =
    localStorage.getItem("restaurantId");

  const [item, setItem] = useState(null);
  const [image, setImage] = useState(null);
  const [model, setModel] = useState(null);
  const [loading, setLoading] = useState(false);

  /*
  FETCH ITEM DETAILS
  */



const fetchDetails = useCallback(
  async () => {
    try {
      setLoading(true); // 🔥 add this

      const res = await axios.get(
        `${BASE_API}/restaurants/items/${itemId}`
      );

      setItem(res.data);

    } catch (error) {
      console.log("Failed to fetch item");
    } finally {
      setLoading(false);
    }
  },
  [itemId]
);

useEffect(() => {
  fetchDetails();
}, [fetchDetails]);
  /*
  UPDATE ITEM
  */
  const handleUpdate = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const formData = new FormData();

      formData.append("name", item.name || "");
      formData.append("price", item.price || 0);
      formData.append("category", item.category || "");
      formData.append("description", item.description || "");
      formData.append("prepTime", item.prepTime || "");
      formData.append("type", item.type || "Veg");
      formData.append("calories", item.calories || 0);

      formData.append(
        "ingredients",
        (item.ingredients || []).join(",")
      );

      if (image) formData.append("image", image);
      if (model) formData.append("model", model);

      await axios.put(
        `${BASE_API}/restaurants/${restaurantId}/items/${itemId}`,
        formData
      );

      alert("✅ Item updated successfully");

      // go back after save
      navigate(-1);

    } catch (err) {
      console.log(err);
      alert("❌ Update failed");
    } finally {
      setLoading(false);
    }
  };

  /*
  LOADING STATE
  */
  if (!item) return <p>Loading...</p>;
return (

  <div className="edit-page">

    <div className="edit-container">

      {/* HEADER */}

<div className="edit-hero">

  <div className="hero-left">

    <button
      className="back-btn"
      onClick={() =>
        navigate(-1)
      }
    >

      ←

    </button>

    <div>

      <h1>
        Edit Food Item
      </h1>

      <p>
        Update your food item
        details and media.
      </p>

    </div>

  </div>

</div>

      {/* FORM CARD */}

      <div className="edit-card">

        {/* IMAGE PREVIEW */}

        {
          item.imageUrl && (

            <div className="preview-wrapper">

              <img
                src={item.imageUrl}
                alt="food"
                className="food-preview"
              />

            </div>

          )
        }

        <form
          onSubmit={handleUpdate}
          className="edit-form"
        >

          {/* BASIC INFO */}

          <div className="form-section">

            <h2>
              Basic Information
            </h2>

            <div className="grid-2">

              <input
                className="input"
                value={item.name || ""}
                onChange={(e) =>
                  setItem({
                    ...item,
                    name: e.target.value
                  })
                }
                placeholder="Food Name"
              />

              <input
                type="number"
                className="input"
                value={item.price || ""}
                onChange={(e) =>
                  setItem({
                    ...item,
                    price: e.target.value
                  })
                }
                placeholder="Price"
              />

              <input
                className="input"
                value={item.category || ""}
                onChange={(e) =>
                  setItem({
                    ...item,
                    category: e.target.value
                  })
                }
                placeholder="Category"
              />

              <select
                className="input"
                value={item.type || "Veg"}
                onChange={(e) =>
                  setItem({
                    ...item,
                    type: e.target.value
                  })
                }
              >

                <option value="Veg">

                  Veg

                </option>

                <option value="Non-Veg">

                  Non-Veg

                </option>

              </select>

            </div>

          </div>

          {/* DESCRIPTION */}

          <div className="form-section">

            <h2>
              Description
            </h2>

            <textarea
              className="textarea"
              value={item.description || ""}
              onChange={(e) =>
                setItem({
                  ...item,
                  description: e.target.value
                })
              }
              placeholder="Food Description"
            />

          </div>

          {/* DETAILS */}

          <div className="form-section">

            <h2>
              Food Details
            </h2>

            <div className="grid-2">

              <input
                className="input"
                value={(item.ingredients || []).join(",")}
                onChange={(e) =>
                  setItem({
                    ...item,
                    ingredients:
                      e.target.value.split(",")
                  })
                }
                placeholder="Ingredients"
              />

              <input
                className="input"
                value={item.prepTime || ""}
                onChange={(e) =>
                  setItem({
                    ...item,
                    prepTime: e.target.value
                  })
                }
                placeholder="Preparation Time"
              />

              <input
                type="number"
                className="input"
                value={item.calories || ""}
                onChange={(e) =>
                  setItem({
                    ...item,
                    calories: e.target.value
                  })
                }
                placeholder="Calories"
              />

            </div>

          </div>

          {/* MEDIA */}

          <div className="form-section">

            <h2>
              Upload Media
            </h2>

            <div className="grid-2">

              <label className="upload-box">

                <span>
                  Upload Image
                </span>

                <input
                  type="file"
                  hidden
                  onChange={(e) =>
                    setImage(
                      e.target.files[0]
                    )
                  }
                />

              </label>

              <label className="upload-box">

                <span>
                  Upload 3D Model
                </span>

                <input
                  type="file"
                  hidden
                  onChange={(e) =>
                    setModel(
                      e.target.files[0]
                    )
                  }
                />

              </label>

            </div>

          </div>

          {/* SAVE BUTTON */}

          <button
            type="submit"
            className="save-btn"
            disabled={loading}
          >

            {
              loading
                ? "Saving..."
                : "Save Changes"
            }

          </button>

        </form>

      </div>

    </div>

  </div>

);
}

